import { Icon, IconProps } from './Icon';

interface MidRangeIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const MidRangeIcon = ({ color = '#C2E2FF', gradient, ...props }: MidRangeIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 45 45"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.9264 15.6052C41.7709 14.4986 41.7378 12.955 40.8466 11.8857L36.4631 6.62545C35.8964 5.94533 35.0568 5.55209 34.1715 5.55209L22.6461 5.55201L11.1206 5.55195C10.2353 5.55194 9.39568 5.94518 8.82891 6.62529L4.44519 11.8857C3.55404 12.955 3.52093 14.4986 4.36543 15.6052L20.2745 36.4516C21.4684 38.0161 23.8234 38.0161 25.0174 36.4516L40.9264 15.6052Z"
      fill={gradient ? `url(#${gradient.id})` : color}
    />
  </Icon>
);
